import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { omit } from 'lodash'
import CardWidget, { Colors } from '../../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../../components/skeletons/CardWidgetSkeleton'
import { PharmaciesDetailsFiltersContext } from '../../../../../context/PharmaciesDetailsFiltersContext'
import { formatCurrency } from '../../../../../utils/Helpers'

const GET_MINIMUM_ORDERS = gql`
  query MinimumOrder($filters: NewOrderFilter) {
    pharmaciesAggs(
      size: 0
      filters: $filters
      aggs: {
        PedidoMinimo: { terms: { field: "pharmacyMinimunOrder.keyword" } }
      }
    ) {
      aggregations
    }
  }
`

const MinimumOrder = (): JSX.Element => {
  const { filters } = useContext(PharmaciesDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_MINIMUM_ORDERS,
    {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { orderCreatedAt: filters.createdAt, ...omit(filters, 'createdAt') }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  const minOrder = isNaN(
    data.pharmaciesAggs.aggregations.PedidoMinimo.buckets[0].key
  )
    ? 'Sem pedido mínimo'
    : formatCurrency(
      data.pharmaciesAggs.aggregations.PedidoMinimo.buckets[0].key
    )

  return (
    <CardWidget title="Pedido mínimo" number={minOrder} color={Colors.blue} />
  )
}

export default MinimumOrder
